import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../_service/authentication.service';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class LoginGuardService implements CanActivate {

  loggedFlag: boolean = false;
  azureAuthFlag: boolean = false;
  userId: string ="";
  constructor(private dataService:AuthenticationService,private router:Router,private msalService:MsalService){ }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean  {
      var obj = JSON.parse(sessionStorage.getItem('appconfig') || '{}');
      this.azureAuthFlag = obj['azureAuthFlag']
    if((this.msalService.instance.getActiveAccount()!=null && this.azureAuthFlag) || !this.azureAuthFlag)
    {
      return true;
    }
    else
    {
      this.router.navigateByUrl('/login');
      return false;
    }
    
  }
  
}
